export const LOG_NAMESPACE = 'onboarding'

export const DIRECTION = Object.freeze({
  Forward: 'Forward',
  Backward: 'Backward',
})

export const VIEWS = Object.freeze({
  Login: 'Login',
  SelectCountry: 'SelectCountry',
  SelectLanguage: 'SelectLanguage',
  BusinessSetup: 'BusinessSetup',
  LocationType: 'LocationType',
  Location: 'Location',
  TravelingFee: 'TravelingFee',
  BusinessHours: 'BusinessHours',
  BusinessServices: 'BusinessServices',
  PortfolioPhotos: 'PortfolioPhotos',
  FinishLite: 'FinishLite',
  BusinessStaffers: 'BusinessStaffers',
  ActivationDelay: 'ActivationDelay',
  ValueProposition: 'ValueProposition',
  FinishBusiness: 'FinishBusiness',
  PollNumberOfStaffers: 'PollNumberOfStaffers',
  PollGoals: 'PollGoals',
  PollOtherApps: 'PollOtherApps',
  PollNumberOfAppointments: 'PollNumberOfAppointments',
  ActivateBusiness: 'ActivateBusiness',
  GoogleAddress: 'GoogleAddress',
})

export const VIEWS_ORDER = Object.freeze([
  VIEWS.Login,
  VIEWS.SelectLanguage,
  VIEWS.SelectCountry,
  VIEWS.BusinessSetup,
  VIEWS.PollNumberOfAppointments,
  VIEWS.LocationType,
  VIEWS.GoogleAddress,
  VIEWS.Location,
  VIEWS.TravelingFee,
  VIEWS.PollNumberOfStaffers,
  VIEWS.BusinessHours,
  VIEWS.BusinessServices,
  VIEWS.PortfolioPhotos,
  VIEWS.PollGoals,
  VIEWS.PollOtherApps,
  VIEWS.ActivateBusiness,
  VIEWS.FinishLite,
  VIEWS.BusinessStaffers,
  VIEWS.ActivationDelay,
  VIEWS.ValueProposition,
  VIEWS.FinishBusiness,
])

export const VIEWS_PROGRESS = Object.freeze({
  [VIEWS.Login]: 5,
  [VIEWS.SelectLanguage]: 5,
  [VIEWS.SelectCountry]: 5,
  [VIEWS.BusinessSetup]: 35,
  [VIEWS.PollNumberOfAppointments]: 40,
  [VIEWS.GoogleAddress]: 45,
  [VIEWS.LocationType]: 45,
  [VIEWS.Location]: 50,
  [VIEWS.TravelingFee]: 55,
  [VIEWS.PollNumberOfStaffers]: 60,
  [VIEWS.BusinessHours]: 65,
  [VIEWS.BusinessServices]: 75,
  [VIEWS.PortfolioPhotos]: 80,
  [VIEWS.PollGoals]: 85,
  [VIEWS.PollOtherApps]: 90,
  [VIEWS.FinishLite]: 100,
  [VIEWS.BusinessStaffers]: 95,
  [VIEWS.ActivationDelay]: 95,
  [VIEWS.ValueProposition]: 100,
  [VIEWS.FinishBusiness]: 100,
})

export const SOLUTION = Object.freeze({
  Mobile: 'Mobile',
  Complete: 'Complete',
})

export const BUSINESS_PACKAGE = Object.freeze({
  Pro: 'P',
  Lite: 'L',
  Unknown: 'U',
})

export const ANALYTICS_SCREEN_NAMES = Object.freeze({
  NUMBER_OF_STAFFERS: 'number_of_staffers',
  NUMBER_OF_APPOINTMENTS: 'number_of_appointments',
  GOALS: 'goals',
  OTHER_APPS: 'other_apps',
  SERVICES: 'services',
  MODAL_IMPORT_FROM_WEBPAGE: 'modal_import_from_webpage',
  MODAL_IMPORT_FROM_IMAGE: 'modal_import_from_image',
  SUGGESTED_SERVICES: 'suggested_services',
  MODAL_ADD_SERVICES: 'modal_add_services',

  // added for toast error reporting
  BUSINESS_ABOUT: 'business_about',
  PASSWORD_SETUP: 'password_setup',
  CLAIM_B_LISTING: 'claim_b_listing',
  ACTIVATION_DELAY: 'activation_delay',
  BUSINESS_HOURS: 'business_hours',
  BUSINESS_SERVICES: 'business_services',
  BUSINESS_STAFFERS: 'business_staffers',
  FINISH_BUSINESS: 'finish_business',
  GDPR: 'gdpr',
  LOCATION_TYPE: 'location_type',
  SELECT_CATEGORY: 'select_category',
  LOCATION_SEARCH: 'location_search',
  LOCATION_FORM: 'location_form',
  JOIN_VENUE: 'join_venue',
  MAP_LOCATION: 'map_location',
  MAP_LOCATION_EMPTY: 'map_location_empty',
})

export const APPLE_APP_LINK = 'https://itunes.apple.com/us/app/booksy-book-your-appointment/id723961236?mt=8'
export const GOOGLE_APP_LINK = 'https://play.google.com/store/apps/details?id=net.booksy.customer'
